import { AvailabilityStatus } from "@workadventure/messages";

export interface PublishableLocalStreamSuccessValue {
    type: "success";
    stream: MediaStream | undefined;
}

export interface PublishableLocalStreamErrorValue {
    type: "error";
    error: Error;
}

export type PublishableLocalStreamValue = PublishableLocalStreamSuccessValue | PublishableLocalStreamErrorValue;

export function shouldMaskVideoForPublishing(
    availabilityStatus: AvailabilityStatus,
    inBackgroundSettings: boolean
): boolean {
    const isUnavailableStatus =
        availabilityStatus === AvailabilityStatus.DENY_PROXIMITY_MEETING ||
        availabilityStatus === AvailabilityStatus.SILENT ||
        availabilityStatus === AvailabilityStatus.DO_NOT_DISTURB ||
        availabilityStatus === AvailabilityStatus.BACK_IN_A_MOMENT ||
        availabilityStatus === AvailabilityStatus.BUSY;

    return isUnavailableStatus && inBackgroundSettings;
}

export function getLocalStreamForPublishing(
    localStreamStoreValue: PublishableLocalStreamValue,
    availabilityStatus: AvailabilityStatus,
    inBackgroundSettings: boolean
): PublishableLocalStreamValue {
    if (
        shouldMaskVideoForPublishing(availabilityStatus, inBackgroundSettings) &&
        localStreamStoreValue.type === "success" &&
        localStreamStoreValue.stream &&
        localStreamStoreValue.stream.getVideoTracks().length > 0
    ) {
        return {
            type: "success",
            stream: new MediaStream(localStreamStoreValue.stream.getAudioTracks()),
        };
    }

    return localStreamStoreValue;
}
